import React from "react";
import image from "../assets/Hero-section-image.png";

const HeroRight = () => {
	return (
		<div className="hero-section-right">
			<img src={image} className="hero-image"></img>
		</div>
	);
};

export default HeroRight;
